import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                next: 'onNextClick',
                back: 'onBackClick'
            },
            submit: 'onSubmit'
        }
    }

    init() {
        this.$counter = this.$('counter')[0]
        this.$fieldsets = Array.from(this.$('fieldset'));
        this.$currentFieldset = this.$('fieldset.is-active')[0];
        this.$feedback = this.$('feedback')[0]
    }

    setActiveFieldset(fieldset) {
        this.$currentFieldset.classList.remove('is-active');
        this.$currentFieldset = null;

        if(fieldset) {
            this.$currentFieldset = fieldset;
            this.$currentFieldset.classList.add('is-active');
            this.updateCounter(this.$fieldsets.indexOf(this.$currentFieldset) + 1)
        }

        this.call('scrollTo', { target: 'top', options: { duration: 0, disableLerp: true } }, 'Scroll')
        this.call('update', null, 'Scroll')
    }

    updateCounter(index) {
        this.$counter.innerText = index;
    }

    showFeedback(feedback) {
        this.el.classList.add('is-complete');

        this.setActiveFieldset(false);
        this.$feedback.classList.add('is-active');

        this.$('feedback-title')[0].innerText = feedback.title
        this.$('feedback-message')[0].innerText = feedback.text
    }

    onNextClick(e) {
        const nextFieldset = this.$fieldsets[this.$fieldsets.indexOf(this.$currentFieldset)+1]
        if(nextFieldset) {
            this.setActiveFieldset(nextFieldset);
        } else {
            console.error('Next fieldset doesn\'t exist')
        }
    }

    onBackClick(e) {
        const prevFieldset = this.$fieldsets[this.$fieldsets.indexOf(this.$currentFieldset)-1]
        if(prevFieldset) {
            this.setActiveFieldset(prevFieldset);
        } else {
            console.error('Prev fieldset doesn\'t exist')
        }
    }

    onSubmit(e) {
        e.preventDefault()
        e.stopPropagation();

        this.el.classList.add('is-loading');

        // Make POST request with FormData
        var formData = new FormData(this.el);
        var xhr = new XMLHttpRequest();

        xhr.open("POST", "/app/themes/kabane/project-form-submit.php");
        xhr.setRequestHeader("Accept", "application/json");
        xhr.responseType = 'json';

        xhr.addEventListener('load', () => {
            console.log(xhr.response);
            this.el.classList.remove('is-loading');

            if (xhr.response !== null && (xhr.status === 200 || xhr.status === 202)) {
                this.showFeedback({
                    title: `Merci ${this.el.elements['firstname'].value}, on a bien reçu ta demande.`,
                    text: `On revient vers vous par courriel dans les prochaines 48h`
                });
            } else {
                this.showFeedback({
                    title: `Désolé ${this.el.elements['firstname'].value}, une erreur s'est produite.`,
                    text: `Merci de réessayer ou de nous contacter par mail si le problème persiste.`
                });
            }
        });

        xhr.send(formData);
    }
}
